var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.055,
    height: 17.792,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.575 3.1a6.183 6.183 0 0 1 1.023.192 4.359 4.359 0 0 1 3.322 4.271v5.458l.4.4.333.335H2.408l.333-.335.4-.4V7.562a4.359 4.359 0 0 1 3.322-4.271 7.571 7.571 0 0 1 1.023-.192m.043-3.1a1.308 1.308 0 0 0-1.328 1.334v.623a5.766 5.766 0 0 0-4.428 5.6v4.893L0 14.234v.89h15.055v-.89l-1.771-1.779V7.562a5.766 5.766 0 0 0-4.428-5.6v-.628A1.308 1.308 0 0 0 7.528 0ZM9.3 16.012H5.756a1.771 1.771 0 1 0 3.542 0Z",
    fill: "#dfe1fc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/notifications-icon.8322076eba3a1ab2ba7fd6e23331ea8e.svg";
export { ForwardRef as ReactComponent };